module.exports = __webpack_public_path__ + "img/pixlr.8aac0204.webp";